import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-safety-notice-dialog',
  templateUrl: './safety-notice-dialog.component.html',
  styleUrls: ['./safety-notice-dialog.component.scss'],
})
export class SafetyNoticeDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SafetyNoticeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { step: string }
  ) {}

  orderStep: string = '';
  contantList = [
    '发送短信成功。若仍未收到验证码，可尝试以下操作：',
    '1.尝试语音验证',
    '2.检查绑定的手机是否欠费',
    '3.检查是否位于短信垃圾箱中',
    '4.请确认您的手机号是否正确',
    '5.可能存在发送延迟，过10分钟后再重试',
    '6.若此电话已注册过，我们就不会再向你发送验证码',
  ];
  ngOnInit() {
    this.orderStep = this.data.step;
  }

  close() {
    this.dialogRef.close();
  }
  sendVoice() {}
}
